export default "__VITE_ASSET__BuL2rpbb__"